var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_200_9074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5439 4.96806C27.2464 2.09102 23.0504 0.5 18.5741 0.5C10.0749 0.5 2.65565 6.39421 0.940975 14.4977C0.685422 15.6765 0.561768 16.8884 0.561768 18.0919C0.561768 23.5575 3.04311 28.446 6.93411 31.694C32.2503 29.4599 31.4095 10.7056 30.5439 4.95981V4.96806ZM10.314 10.582H23.6275C24.5096 10.582 25.2185 11.2992 25.2185 12.173C25.2185 13.0468 24.5013 13.764 23.6275 13.764H10.314C9.43193 13.764 8.72298 13.0468 8.72298 12.173C8.72298 11.2992 9.44017 10.582 10.314 10.582ZM17.7333 26.2614H10.314C9.43193 26.2614 8.72298 25.5442 8.72298 24.6704C8.72298 23.7965 9.44017 23.0793 10.314 23.0793H17.7333C18.6154 23.0793 19.3243 23.7965 19.3243 24.6704C19.3243 25.5442 18.6071 26.2614 17.7333 26.2614ZM23.6275 20.0127H10.314C9.43193 20.0127 8.72298 19.2955 8.72298 18.4217C8.72298 17.5479 9.44017 16.8307 10.314 16.8307H23.6275C24.5096 16.8307 25.2185 17.5479 25.2185 18.4217C25.2185 19.2955 24.5013 20.0127 23.6275 20.0127Z",
    fill: "url(#paint0_linear_200_9074)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9676 30.2266C32.7945 29.5919 32.9511 28.8417 33.454 27.9679C33.5447 27.8112 33.6436 27.6629 33.7178 27.5722C35.5809 24.7446 36.5618 21.4636 36.5618 18.0755C36.5618 14.2092 35.2923 10.5326 32.9346 7.4989C33.726 12.7748 34.4927 28.9983 15.7549 35.618C16.571 35.7334 17.3954 35.8158 18.2445 35.8158C19.7283 35.8158 21.8717 35.4449 23.1329 35.0904C24.4684 34.7194 25.7709 34.2166 25.8286 34.1918C26.2903 34.0187 26.7684 33.928 27.2548 33.928H27.2713C27.8071 33.928 28.3264 34.0352 28.7634 34.2166L34.6493 36.3434L32.9594 30.2431V30.2266H32.9676Z",
    fill: "url(#paint1_linear_200_9074)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6111 10.582C24.4931 10.582 25.2021 11.2992 25.2021 12.173C25.2021 13.0468 24.4849 13.764 23.6111 13.764H14.1968C15.1531 14.745 16.1011 15.7755 16.9997 16.8224H23.6111C24.4931 16.8224 25.2021 17.5396 25.2021 18.4134C25.2021 19.2873 24.4849 20.0045 23.6111 20.0045H19.514C21.105 22.2385 22.3086 24.456 22.7455 26.4675C31.7475 19.8561 31.1458 9.06515 30.5275 4.95981C27.23 2.08278 23.034 0.5 18.5577 0.5C13.5456 0.5 8.92088 2.55267 5.60693 5.89959C6.77753 6.86409 8.74776 8.52107 10.9406 10.5737H23.6111V10.582Z",
    fill: "url(#paint2_linear_200_9074)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_200_9074",
    x1: 0.561768,
    y1: 16.1052,
    x2: 30.8572,
    y2: 16.1052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB0060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F70160"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D51362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#BB2163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A82B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#9C3165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#993366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_200_9074",
    x1: 31.3189,
    y1: 21.917,
    x2: 37.345,
    y2: 21.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#993366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#993366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#993366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_200_9074",
    x1: 14.4606,
    y1: 4.16018,
    x2: 32.7615,
    y2: 21.5213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#2E3595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#3A348F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5C3480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#763374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#89336C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#953367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#993366"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_200_9074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 35.8434,
    fill: "white",
    transform: "translate(0.561768 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTocom);
export default __webpack_public_path__ + "static/media/tocom.66215140ac75643e62a7780c339afe6c.svg";
export { ForwardRef as ReactComponent };